import { baseApi } from "../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../core/data/rtk/apiResponseType";
import {
  PromotionPayloadType,
  BulkPromotionPayloadType,
  SimplePromotionPayloadType,
  SimpleBulkPromotionPayloadType,
} from "../types/promotionRequest";
import { PromotionResponseType } from "../types/promotionResponse";

export const promotionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    promoteStudent: builder.mutation<
      ApiResponseType<{ promotion: PromotionResponseType }>,
      SimplePromotionPayloadType
    >({
      query: (payload) => ({
        url: `students/${payload.student_id}/promote`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Students"],
    }),

    promoteStudentsBulk: builder.mutation<
      ApiResponseType<{ count: number }>,
      SimpleBulkPromotionPayloadType
    >({
      query: (payload) => ({
        url: "students/bulk-promote",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Students"],
    }),
  }),
});

export const { usePromoteStudentMutation, usePromoteStudentsBulkMutation } =
  promotionApi;
